/**
 * Nested menu tools.
 */
H_Tools.nestedmenu = (() => {
    // console.log('Nested menu tools initialized...');

    function getMenuItemCaret(li) {
        return li.children[0].children[1].children[0];
    }

    function isElementInsideMenu(element) {
        while ((element = element.parentElement) !== null) {
            if (element.nodeType !== Node.ELEMENT_NODE) {
                continue;
            }
            if (element.isEqualNode(menu)) {
                return true;
            }
        }
        return false;
    }

    /**
     * Shows menu item children <li class="menu-item-has-children">
     */
    function activateMenuItem(menu, li) {
        // console.log('Activating menu item');

        // validate
        if (!li) {
            return;
        }

        const ul = li.children[1];
        if (ul) {
            li.classList.add('-open');

            let caret = getMenuItemCaret(li);
            if (caret) {
                caret.classList.add('-open');
                caret.setAttribute('aria-expanded', 'true');
            }

            ul.classList.add('-open');
            li.dispatchEvent(new Event('submenuopened'));
        }

        // activate parents <li> + <ul>
        const ancestors = H_Tools.ancestors.getAllAncestors(
            li,
            menu,
            'menu-item-has-children'
        );
        for (let i = 0; i < ancestors.length; i++) {
            activateMenuItem(menu, ancestors[i]);
        }
    }

    /**
     * Hides menu item children <li class="menu-item-has-children">
     */
    function deactivateMenuItem(li) {
        // console.log('Deactivating menu item');

        // validate
        if (!li) {
            return;
        }

        li.classList.remove('-is-clicked');

        // deactivate <ul>
        const ul = li.children[1];
        if (ul) {
            li.classList.remove('-open');

            let caret = getMenuItemCaret(li);
            if (caret) {
                caret.classList.remove('-open');
                caret.setAttribute('aria-expanded', 'false');
            }

            ul.classList.remove('-open');
            ul.classList.remove('-is-out-of-bounds-right');
            ul.classList.remove('-is-out-of-bounds-bottom');
            ul.classList.remove('-is-out-of-bounds-top-and-bottom');
        }

        // deactivate children <li> + <ul>
        const children = li.querySelectorAll('.menu-item-has-children');
        for (let i = 0; i < children.length; i++) {
            deactivateMenuItem(children[i]);
        }
    }

    /**
     * Toggles the supplied menu item.
     *
     * @return int An integer value indicating the result of the toggle, where -1 = closed, 0 = failure, 1 = opened
     */
    function toggleMenuItem(menu, li) {
        // console.log('Toggling menu item');

        if (!li) {
            return 0;
        }

        if (li.classList.contains('-open')) {
            deactivateMenuItem(li);
            return -1;
        } else {
            activateMenuItem(menu, li);
            return 1;
        }
    }

    /**
     * Reset all menu-items' state.
     */
    function resetMenuItems(menu) {
        const items_with_children = menu.querySelectorAll(
            '.menu-item-has-children'
        );
        for (let i = 0; i < items_with_children.length; i++) {
            deactivateMenuItem(items_with_children[i]);
        }
    }

    /**
     * Close submenus with ESC key
     */
    document.addEventListener('keydown', function (evt) {
        // console.log('Close submenu');
        evt = evt || window.event;
        if (evt.key === 'Escape' || evt.key === 'Esc' || evt.keyCode === 27) {
            var openSubmenus = document.querySelectorAll(
                '.menu-item-has-children.-open'
            );
            openSubmenus.forEach(function (submenu) {
                deactivateMenuItem(submenu);
            });
        }
    });

    // Return an object to expose inner functions
    return {
        isElementInsideMenu: isElementInsideMenu,
        activateMenuItem: activateMenuItem,
        deactivateMenuItem: deactivateMenuItem,
        toggleMenuItem: toggleMenuItem,
        resetMenuItems: resetMenuItems,
    };
})();
